module.exports = __webpack_public_path__ + "img/hero.f550fb58.jpg";